/**
 * Ported from `app/src/lib/utils/assert-never.ts` @ `e8e8fecb4ec5`.
 * Bindery is canonical for this module from 2026-09-04; reconcile app-side drift toward this copy.
 */

/**
 * Exhaustiveness guard for `switch` statements and union narrowing.
 *
 * Call it in the `default` branch once every case is handled. TypeScript
 * only infers `never` for `value` when the switch is genuinely exhaustive,
 * so adding a new union member turns this call into a compile error —
 * forcing the new case to be handled. At runtime the branch is unreachable
 * for well-typed inputs; if it is somehow reached (corrupt data) it throws.
 *
 * @param value - The value that should have been narrowed to `never`.
 * @param label - Optional context label for the thrown error message.
 */
export function assertNever(value: never, label = "value"): never {
  throw new Error(`Unexpected ${label}: ${String(value)}`);
}
